import { render, staticRenderFns } from "./PlaybookEvent.vue?vue&type=template&id=3163caca&scoped=true&"
import script from "./PlaybookEvent.vue?vue&type=script&lang=js&"
export * from "./PlaybookEvent.vue?vue&type=script&lang=js&"
import style0 from "./PlaybookEvent.vue?vue&type=style&index=0&id=3163caca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163caca",
  null
  
)

export default component.exports